// extracted by mini-css-extract-plugin
export default {"Draggable":"Draggable_Draggable__nrQ3o","active":"Draggable_active__lngGo","img":"Draggable_img__yCxrj"};